import { alpha, Theme } from "@mui/material";

const useStyles = (theme: Theme) => ({
  container: {
    backgroundColor: alpha(theme.palette.background.paper, 0.98),
    display: "flex",
    flexDirection: "row",
    maxWidth: "1150px",
    minWidth: "850px",
    height: "650px",
    position: "absolute",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "auto",
    marginBottom: "auto",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
  containerTab: {
    minWidth: "300px",
    p: "15px 5px",
    borderRight: "1px solid" + theme.palette.color.stroke,
    backgroundColor: theme.palette.background.default,
  },
  tabs: {
    height: "100%",
    "& button": {
      backgroundColor: theme.palette.background.default,
      color: theme.palette.text.secondary,
      paddindBottom: "0px !important",
      textTransform: "none",
    },
    "& .MuiTabs-flexContainer": {
      height: "42px",
    },
    "& button.Mui-selected": {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
    },
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.primary.main,
    },
  },
  pageTitle: {
    width: "100%",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "0.96rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: theme.palette.text.primary,
    textAlign: "center",
  },
  buttomEnd: {
    textTransform: "none",
  },
  containerData: {
    padding: 2,
    width: "100%",
    height: { xs: "90%", md: "100%" },
  },
  boxOP: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    p: 2,
    borderRadius: "5px",
    mb: 2,
  },
  text: { fontSize: "0.95rem", fontWeight: 500 },
  textFine: {
    fontSize: "0.86rem",
    mt: "-2px",
    color: theme.palette.text.secondary,
  },
  textFieldSelect: {
    fontSize: "14px",
    width: "100%",
    "& .MuiInputBase-input": {
      fontSize: "0.9rem",
      height: "20px!important",
    },
    '& input[type="number"]::-webkit-outer-spin-button': { display: "none" },
    '& input[type="number"]::-webkit-inner-spin-button': { display: "none" },
    '& input[type="number"]': { MozAppearance: "textfield" },
    "& .MuiOutlinedInput-root": {
      boxShadow: "none",
      "&.Mui-focused": { boxShadow: "none", border: "none" },
    },
  },
  textField: {
    fontSize: "14px",
    width: "100%",
    mb: 2,
    "& .MuiInputBase-input": {
      fontSize: "0.9rem",
      height: "20px!important",
    },
    '& input[type="number"]::-webkit-outer-spin-button': { display: "none" },
    '& input[type="number"]::-webkit-inner-spin-button': { display: "none" },
    '& input[type="number"]': { MozAppearance: "textfield" },
    "& .MuiOutlinedInput-root": {
      boxShadow: "none",
      "&.Mui-focused": { boxShadow: "none", border: "none" },
    },
  },
  textAdorment: {
    ml: "-5px",
    fontSize: "0.875em",
    fontWeight: 800,
    color: theme.palette.text.disabled,
    width: "max-content",
  },

  boxPreview: {
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    p: 2,
    marginY: 2,
    height: "140px",
    borderRadius: 1,
  },
  boxLine: {
    display: "flex",
    flexDirection: "column",
    alignItems: "end",
  },
  textPreview: {
    color: "#7f8c8d",
    fontSize: 11,
  },
  icon: {
    width: 16,
    height: 16,
    verticalAlign: "middle",
    marginRight: 6,
  },
  pageTitleMobile: {
    width: "calc(100% + 40px)",
    ml: "-40px",
    height: "56px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "1rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "1px",
    color: theme.palette.text.primary,
    textAlign: "center",

    //borderBottom: "1px solid" + theme.palette.color.appBarBorder,
  },

  drawerMobile: {
    zIndex: 1500,
  },
  containerTabMobile: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    borderBottom: "1px solid" + theme.palette.color.stroke,
    backgroundColor: theme.palette.background.default,
  },
  containerMobile: {
    backgroundColor: alpha(theme.palette.background.paper, 0.98),
    display: "flex",
    flexDirection: "column",
    width: "99dvw",
    height: "99dvh",
    position: "absolute",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "auto",
    marginBottom: "auto",
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
  },
});
export default useStyles;
